import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const GlobalRatesConfirmModel = ({ show, onClose, handleEditRate, name, originalCost, newCost }) => {
  
  return (
    <Modal className="modal-delete" show={show} onHide={onClose} centered>
      <Modal.Body>
      <CloseIcon handleModalClose={onClose}/>
      <Modal.Title style={{ margin: '16px 0 8px', fontSize: '18px', fontWeight: '600' }}>
        Confirm Global Rate Update
      </Modal.Title>
        <p style={{ margin: '30px 10px 10px'}}>
          Update <strong>{name} </strong> global rate from
          <strong> RM {originalCost} </strong> to
          <strong> RM {newCost}</strong>?
        </p>
      <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
        <Button variant="primary" onClick={handleEditRate} style={{ minWidth: 160 }}>
          Yes
        </Button>
        <Button variant="danger" onClick={onClose} style={{ minWidth: 160 }}>
          No
        </Button>
      </div>
      </Modal.Body>
    </Modal>
  );
};

export default GlobalRatesConfirmModel;
